import { Grid } from "@mui/material";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import MxEmptyBody from "@rf-l1/empty-sections/MxEmptyBody";
import MxEmptyCard from "@rf-l1/empty-sections/MxEmptyCard";
import MxEmptyIcon from "@rf-l1/empty-sections/MxEmptyIcon";
import MxTypography from "@rf-l1/MxTypography";
import { memo } from "react";
import { useNavigate } from "react-router-dom";

interface IProps {
  path: string;
  title: string;
  buttonMessage: string;
}

const Page404 = memo((props: IProps) => {
  const { path = "/", title = "URL no válida", buttonMessage = "" } = props;
  const navigate = useNavigate();
  return (
    <MxEmptyCard size="page">
      <MxEmptyIcon variant="404" />
      <MxEmptyBody>
        <Grid container rowSpacing={2}>
          <Grid item xs={12}>
            <MxTypography variant="body2">{title}</MxTypography>
          </Grid>

          <Grid item xs={12}>
            <MxButton2
              variant="contained"
              color="primary"
              onClick={() => navigate(path)}
            >
              {buttonMessage}
            </MxButton2>
          </Grid>
        </Grid>
      </MxEmptyBody>
    </MxEmptyCard>
  );
});

export default Page404;
